import React from 'react';
import { Link } from 'react-router-dom';

export default function SleepApneaQuizSection() {
    return (
        // Premium soft gradient background matching the image's aesthetic
        <section className="relative py-24 px-6 bg-gradient-to-br from-primary/10 via-primary/5 to-primary/15 overflow-hidden">

            {/* Subtle decorative background blur to match the modern site UI */}
            <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[40rem] h-[40rem] bg-white/40 rounded-full blur-[100px] pointer-events-none"></div>

            <div className="max-w-4xl mx-auto text-center relative z-10">

                {/* Match heading styles (font-extrabold, tracking-tight) from the rest of the site */}
                <h2 className="text-3xl md:text-5xl font-extrabold text-primary mb-6 tracking-tight drop-shadow-sm">
                    Are you at risk? <br className="hidden sm:block" /> Take Our Sleep Apnea Quiz
                </h2>

                {/* Match body text styles (text-lg, leading-relaxed, gray-700) */}
                <p className="text-gray-700 text-lg md:text-xl leading-relaxed mb-12 max-w-3xl mx-auto font-medium">
                    Do you doze off easily during the day? Daytime drowsiness may be a sign that you should be evaluated by a sleep physician for obstructive sleep apnea. Take this brief quiz and contact Dental Sleep Care for more information.
                </p>

                {/* Upgraded Buttons: Added rounded-xl, deep shadows, and hover lift effects */}
                <div className="flex flex-col sm:flex-row items-center justify-center gap-5 w-full">

                    {/* Adult Quiz Button */}
                    <Link
                        to="https://start.smbjugaad.com/assessment/sleep-apnea-adult"
                        className="group relative w-full sm:w-auto min-w-[340px] bg-primary hover:bg-primary/90 text-white font-bold text-lg py-4 px-8 rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 flex items-center justify-center gap-3"
                    >
                        Sleep Apnea Quiz for Adults
                        <span className="transform transition-transform group-hover:translate-x-1">→</span>
                    </Link>

                    {/* Children Quiz Button */}
                    <Link
                        to="https://start.smbjugaad.com/assessment/sleep-dental-child"
                        className="group relative w-full sm:w-auto min-w-[340px] bg-secondary hover:bg-secondary/90 text-white font-bold text-lg py-4 px-8 rounded-xl shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 flex items-center justify-center gap-3"
                    >
                        Sleep Apnea Quiz for Children
                        <span className="transform transition-transform group-hover:translate-x-1">→</span>
                    </Link>

                </div>
            </div>
        </section>
    );
}